import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseCell, BaseText } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

enum colorType {
  default = 'default',
  positive = 'positive',
  negative = 'negative'
}

interface DataProps {
  value: string;
  color: string;
  isHideable: boolean;
  subValue?: string;
}

interface Props {
  text: DataProps;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationCell',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
  text: DataProps;
};



const component = computed(() => {
  return props.text.isHideable ? Money : 'div';
});

const color = computed(() => {
  switch (props.text.color) {
    case colorType.positive:
      return NebraskaColors.statusPositive;

    case colorType.negative:
      return NebraskaColors.statusNegative;

    case colorType.default:
    default:
      return NebraskaColors.elementPrimary;
  }
});

return { __sfc: true,colorType, props, component, color, BaseCell, BaseText }
}

})